/**
 * "At a glance" date formatting: today shows just the time, this year shows
 * day + month, any other year shows just the year — never all of them at
 * once. For views where a full date/time is more noise than signal.
 */
export function glanceDateFormatOptions(
	date: Date,
	now: Date = new Date(),
): Intl.DateTimeFormatOptions {
	if (date.toDateString() === now.toDateString()) {
		return { hour: "2-digit", minute: "2-digit" };
	}
	if (date.getFullYear() === now.getFullYear()) {
		return { day: "numeric", month: "long" };
	}
	return { year: "numeric" };
}
